import React from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import ServicesSection from "../components/ServicesSection";
import PhilosophySection from "../components/PhilosophySection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#F5F1E8]">
      <Header />
      <HeroSection />
      <ServicesSection />
      <PhilosophySection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;